import { privateAxios } from "../axiosInstances";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ticketingSalesQueryKeys } from "../query-keys/event-ticketing-sales.query-keys";
import { creditNotesQueryKeys } from "../query-keys/credit-note.query-keys";

type UpdateCreditNoteStatusPayload = {
  creditNoteId: string;
  status: "accepted" | "refused";
  eventId?: string;
};

const updateCreditNoteStatus = async ({
  creditNoteId,
  status,
}: UpdateCreditNoteStatusPayload) => {
  const { data } = await privateAxios.patch(
    `/credit-notes/${creditNoteId}/status`,
    {
      status,
    }
  );
  return data;
};

export const useUpdateCreditNoteStatusMutation = (eventId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCreditNoteStatus,
    onSuccess: () => {
      if (eventId) {
        queryClient.invalidateQueries({
          queryKey: ticketingSalesQueryKeys.event(eventId),
        });
      }
      queryClient.invalidateQueries({
        queryKey: creditNotesQueryKeys.all,
      });
    },
  });
};
